var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"redeem-maintenance"}},[_c(_setup.BIconGear,{staticClass:"icon"}),_c('h3',[_vm._v(_vm._s(_vm.$t('redeem.maintenance.heading')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('redeem.maintenance.text'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }